import { useMxfNestToast, useFetchMxfNestApi } from "hooks/useMxfApiNest";
import { getURLWithParams } from "utils/context";

export const usePisCofinsDetail = id =>
  useFetchMxfNestApi(id ? `pis-cofins/${id}` : null);

export const usePisCofinsList = (params = {}) =>
  useFetchMxfNestApi(getURLWithParams("pis-cofins", params));

export const usePisCofins = (id = null) => {
  const { onSend } = useMxfNestToast();

  const onCreate = async data => {
    const endpoint = id ? `pis-cofins/${id}` : "pis-cofins";
    const type = id ? "PATCH" : "POST";

    onSend({
      endpoint,
      messageSuccess: id
        ? "Classificação editada com sucesso"
        : "Classificação cadastrada com sucesso",
      messageFail: id
        ? "Não foi possível editar a Classificação"
        : "Não foi possível cadastrar a Classificação",
      data,
      type,
      redirect: !id,
      fieldGetId: "class_piscofins_id",
      urlRedirect: "/legislacao/class-pis-cofins/editar",
    });
  };

  const onRemove = async idToDelete => {
    const endpoint = `pis-cofins/${idToDelete}`;

    return onSend({
      endpoint,
      messageSuccess: "Classificação PIS/COFINS apagada com sucesso",
      messageFail: "Não foi possível deletar Classificação",
      type: "DELETE",
    });
  };
  return {
    onCreate,
    onRemove,
  };
};
